import React from 'react'
import {InfoCardProps} from '../utils/types'

const KeyIcon = () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='mb-1'
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0z' />
      <path d='M15 9h.01' />
    </svg>
  )
  
  const UserIcon = () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='mb-1'
    >
      <path stroke='none' d='M0 0h24v24H0z' fill='none' />
      <path d='M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0' />
      <path d='M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2' />
    </svg>
  )

const InfoCard: React.FC<InfoCardProps> = ({type, title, description}) => {
  return (
    <div className='card mb-4 p-4' style={{background: '#F6F6F6'}}>
      <div className='mt-1'>
        {type === 'info' && (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='mb-1'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0' />
            <path d='M12 8h.01' />
            <path d='M11 12h1v4h1' />
          </svg>
        )}
        {type === 'permission' && (
        <KeyIcon />
        )}
        {type === 'access' && (
          <UserIcon />
        )}
        <span className='fw-bold fs-6 mx-2'>{title}</span>
      </div>
      <div 
        className='fs-6 fw-semibold mt-2' 
        style={{color: '#5A5A5A'}}
      >
        {typeof description === 'string' ? (
          <div dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          description
        )}
      </div>
    </div>
  )
}

export default InfoCard
